module.exports = __webpack_public_path__ + "img/iphone.4d7219ad.png";